import { render, staticRenderFns } from "./PriorityZones.vue?vue&type=template&id=2c383caa&scoped=true"
import script from "./PriorityZones.vue?vue&type=script&lang=js"
export * from "./PriorityZones.vue?vue&type=script&lang=js"
import style0 from "./PriorityZones.vue?vue&type=style&index=0&id=2c383caa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c383caa",
  null
  
)

export default component.exports